import { baseUrl } from "../../../boot/index";
import axios from "axios";



// add DmsStatuss
export const addDmsStatus = async (formData) => {
    const token = localStorage.getItem("authToken")
    try {
      const response = await axios.post(`${baseUrl}cleaningappfunctions/dms/app/v1/create-dmsStatus`, formData, {
        headers: {
          "auth-token": token,
        }
      },)
      return response;
    } catch (error) {
      console.log({ error })
      throw error
    }
  }


// delete DmsStatuss 
export const deleteDmsStatus = async (ROWID) => {
  console.log({ ROWID })
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.delete(`${baseUrl}cleaningappfunctions/dms/app/v1/delete-dmsStatus/${ROWID}`, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    console.log("Error is - ", error)
    throw error
  }
}


// update employe
export const updateDmsStatus = async (data) => {
  console.log({ data })
  const ROWID = data.ROWID
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.put(`${baseUrl}cleaningappfunctions/dms/app/v1/update-dmsStatus/${ROWID}`, data, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}


// total count Attendance
export const countDmsStatuss = async (formData) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/dms/app/v1/count-dmsStatus`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}